const useStoreByName = (_context) => {
    _context.store.$storeByName = (name) => {
        var _a;
        const stores = _context.pinia;
        return ((_a = stores === null || stores === void 0 ? void 0 : stores._s) === null || _a === void 0 ? void 0 : _a.get(name)) || undefined;
    };
};
export { useStoreByName };
//# sourceMappingURL=storeByName.js.map